module.exports = __webpack_public_path__ + "static/img/wict-weixin.99774a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wict-weixin.png
// module id = z4dx
// module chunks = 0